/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_Faq_Safe_AInputs */

const en_wc_faq_safe_a = /** @type {(inputs: Wc_Faq_Safe_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Our desktop download links lead to the developers' GitHub releases at storytold/wordcraft. Use the download guide to choose your platform, then check the release notes and published checksums before installing.`)
};

/**
* | output |
* | --- |
* | "Our desktop download links lead to the developers' GitHub releases at storytold/wordcraft. Use the download guide to choose your platform, then check the rel..." |
*
* @param {Wc_Faq_Safe_AInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_faq_safe_a = /** @type {((inputs?: Wc_Faq_Safe_AInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_Faq_Safe_AInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_faq_safe_a(inputs)
});
export { wc_faq_safe_a as "wc.faq.safe.a" }